import React, { useState } from "react";
import { Button } from "react-bulma-components/full";
import ETAPE3 from "../../assets/img/etape3.webp";

import DeveloppersService from "../../services/Developpers";
import User from "../../services/User";
import landingPV from "../../assets/img/PV.jpg";
import styled from "styled-components";
import { Square } from "../../assets/style/commonStyledComponent";
export const EndOfLanding = (props) => {
  const [loading, setLoading] = useState(false);
  const { triggerRedirect } = props;
  const handleAnonymouseSignup = async () => {
    // //Fetching developper defaultScenarios id for later use
    setLoading(true);
    const devRef = await DeveloppersService.getByDevelopper();
    const devData = await User.get(devRef.account);
    console.log({ devData });
    try {
      localStorage.setItem("scenarioTemplates", devData.defaultScenarios);
    } catch (e) {
      console.log("No scenarios were found");
    }
    setLoading(false);
    triggerRedirect(true);
  };

  const StepContainer = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align &.step-5 {
      background: url(${landingPV});
    }
  `;

  const StartButton = styled(Button)`
    z-index: 9999;
    position: absolute;
    right: 2% !important;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    background-color: ${(props) => props.theme.main};
    border-radius: 100px;
    color: ${(props) => props.theme.mainText || "white"};
    padding: 35px;
    font-size: 2rem;
    &:hover {
      background-color: ${(props) => props.theme.third};
      color: ${(props) => props.theme.secondText || "white"};
      border: none;
    }
    &.is-loading {
      &.is-info {
        &:after {
          color: ${(props) => props.theme.main};
          border-color: transparent transparent ${(props) => props.theme.main}
            ${(props) => props.theme.main} !important;
        }
      }
    }
  `;

  const Img = styled.img`
    position: relative;
    margin: auto;
    width: 100% !important;
  `;

  return (
    <StepContainer>
      <Square>
        <Img className="step-3" src={ETAPE3}></Img>
      </Square>
      <StartButton loading={loading} onClick={handleAnonymouseSignup}>
        Je commence
      </StartButton>
    </StepContainer>
  );
};
